module.exports = __webpack_public_path__ + "static/img/pi-roach-cover-german.9d6cfcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pi-roach-cover-german.jpg
// module id = 183
// module chunks = 0